import { render, staticRenderFns } from "./map-bottom-popup.vue?vue&type=template&id=0db52c5f"
import script from "./map-bottom-popup.vue?vue&type=script&lang=js"
export * from "./map-bottom-popup.vue?vue&type=script&lang=js"
import style0 from "./map-bottom-popup.vue?vue&type=style&index=0&id=0db52c5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports